import { AuthRoutePaths } from '@/features/auth';
import { lazyImport } from '@/utils/lazyImport';

const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');

export const publicRoutes = [
  {
    path: `/${AuthRoutePaths.index}/*`,
    element: <AuthRoutes />,
  },
];
